import { Originator } from 'src/generated/signalR/originator';
import { UserStatusInfoRemoteDto } from 'src/generated/signalR/user-status-info-remote-dto';

export class SamwinStatusChanged {
   public static readonly type = '[Samwin User Status] Status Changed';

   constructor(public status: number, public endTime: Date, public allowedStatusResets: number, public originator: Originator) {}
}

export class UserStatusInfosChangedByServer {
   public static readonly type = '[Samwin User Status] Updating User Status Infos';

   constructor(public userStatusInfos: UserStatusInfoRemoteDto[]) {}
}

export class RequestUserStatusChange {
   public static readonly type = '[Samwin User Status] Requesting User Status Change';

   constructor(public status: number, public originator: Originator) {}
}

export class SamwinAgentStateChangedByServer {
   public static readonly type = '[Samwin User Status] Agent State Changed';

   constructor(public mode: boolean) {}
}
